// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"28c91563","166":"c573db3f","250":"2ce74e98","424":"2a817ab7","630":"877ba028"}[chunkId] + ".chunk.js";
};